import React from 'react'
import { LuHouse } from 'react-icons/lu'

import NextBreadcrumbs from './_breadcrumb'
import { BreadcrumbsWrapper } from './Breadcrumbs.styles'

const labelsMap = {
  account: 'My Account',
  assets: 'Assets',
  contacts: 'All Contacts',
  home: 'Home',
  share: 'Smart Share',
  ptu: 'PTU',
  my: 'My Assets',
} as Record<string, string>

export const Breadcrumbs = () => {
  return (
    <BreadcrumbsWrapper>
      <LuHouse size="14" />
      <NextBreadcrumbs
        rootLabel="Home"
        transformLabel={(slug) => labelsMap[slug] ?? slug}
        useDefaultStyle
      />
    </BreadcrumbsWrapper>
  )
}
